module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Medium-d19dcc38a149cb85c5d85eb28486992c.otf";